export function stepsMobileText() {
  document.addEventListener("DOMContentLoaded", function () {
    function updateText() {
      var isMobile = window.innerWidth <= 767;
      document.querySelectorAll(".responsive-text").forEach(function (el) {
        var rowIndex = el.getAttribute("data-row-index");
        var mobileText = el.getAttribute("data-mobile-text") || "";

        if (isMobile) {
          el.innerHTML = `<span class="mr-1">${rowIndex}.</span><span>${mobileText}</span>`;
        } else {
          el.innerHTML = el.dataset.fullText || el.innerHTML;
        }
      });
    }

    document.querySelectorAll(".responsive-text").forEach(function (el) {
      el.dataset.fullText = el.innerHTML;
    });

    updateText();
    window.addEventListener("resize", updateText);
  });
}
